'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { denormalizeFilterName, FEATURED_BRANDS_PATH } from '@libs/algolia';
export const useFeaturedBrand = () => {
  const $ = _c(2);
  const pathname = usePathname();
  const isFeaturedBrandPage = pathname?.includes(FEATURED_BRANDS_PATH);
  if (isFeaturedBrandPage) {
    let t0;
    if ($[0] !== pathname) {
      t0 = denormalizeFilterName(pathname?.split("/")[2] ?? "");
      $[0] = pathname;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  return null;
};